import { render } from "./TariffCreation.vue?vue&type=template&id=3a7b842f"
import script from "./TariffCreation.vue?vue&type=script&lang=js"
export * from "./TariffCreation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__